// #region STORAGE KEYS
export const STORAGE_ITEM_XSOLLA_SPECIAL_OFFER_UPSELL_OFFER =
  'xsolla.specialOffer.upsellOffer';
export const STORAGE_ITEM_XSOLLA_INTERSTITIAL_OFFER_UPSELL_OFFER =
  'xsolla.interstitialOffer.upsellOffer';
export const STORAGE_ITEM_DEBUG_CONFIG = 'featureFlags.debug';
export const STORAGE_ITEM_XSOLLA_SPECIAL_OFFER = 'xsolla.specialOffer';
export const STORAGE_ITEM_XSOLLA_INTERSTITIAL_OFFER =
  'xsolla.interstitialOffer';
export const STORAGE_ITEM_STORE_OFFER_VIEWS = 'store.offerViews';
export const STORAGE_ITEM_STORE_CACHED_VIRTUALIZER = 'store.cachedVirtualizer';
export const STORAGE_ITEM_INTERSTITIAL_HISTORY = 'interstitial.history';
// #endregion STORAGE KEYS

// #region DIALOG KEYS
export const DIALOG_ID_SPECIAL_OFFER_PREVIEW = 'special-offer-review-dialog';
export const DIALOG_ID_SPECIAL_REWARD_PREVIEW = 'special-reward-review-dialog';
export const DIALOG_ID_INTERSTITIAL_OFFER_TO_UPSELL =
  'interstitial-offer-to-upsell-dialog';
export const DIALOG_ID_UPSELL_OFFER = 'upsell-offer-dialog';
export const DIALOG_ID_INTERSTITIAL_OFFER = 'interstitial-offer-dialog';
export const DIALOG_ID_INTERSTITIAL_OFFER_UPSELL =
  'interstitial-offer-upsell-dialog';
export const DIALOG_ID_INTERSTITIAL_SURVEY = 'interstitial-survey-dialog';
// #endregion

// #region REACT-QUERY KEYS
// Subscription query key
export const QUERY_KEY_SUBSCRIPTION = 'subscription';
export const QUERY_KEY_SUBSCRIPTION_USER = 'subscription-user';
export const QUERY_KEY_SUBSCRIPTION_INTERSTITIAL = 'subscription-interstitial';

// ClubStore query key
export const QUERY_KEY_ROSTER = 'clubstore-player-rosters';
export const QUERY_KEY_EXCLUSIVE_ITEMS = 'clubstore-exclusive-items';
export const QUERY_KEY_MISSION_ITEMS = 'clubstore-mission-items';
export const QUERY_KEY_MISSION_CLAIM_STATUS = 'clubstore-claim-all-status';
export const QUERY_KEY_MISSION_PROGRESS_STATUS =
  'clubstore-mission-progress-status';

// Store Revamp Offers key
export const QUERY_KEY_OFFER_V2 = 'offer-v2';
export const QUERY_KEY_OFFER_VIRTUALIZATION = 'offer-virtualization';
export const QUERY_KEY_USER_STOCKS_V2 = 'offer-stocks-v2';

// Interstitial query key
export const QUERY_KEY_INTERSTITIAL = 'interstitial';
// #endregion

// #region SUPERSTAR QUERY KEY
export const QUERY_KEY_SUPERSTAR = 'superstar';
// #endregion SUPERSTAR QUERY KEY

// #region RBE QUERY KEY
export const QUERY_KEY_RBE = 'rbe';
export const QUERY_KEY_RBE_SOLO_USER_PROGRESS = 'rbe-solo-user-progress';
export const QUERY_KEY_RBE_GLOBAL_USER_PROGRESS = 'rbe-global-user-progress';
export const QUERY_KEY_RBE_REWARDS = 'rbe-rewards';
export const QUERY_KEY_RBE_LEADERBOARD = 'rbe-leaderboard';
// #endregion RBE QUERY KEY

// #region SUPERSTAR QUERY KEY
export const QUERY_KEY_SUPERSTAR_SEARCH = 'superstar-search';
export const QUERY_KEY_SUPERSTAR_DETAILS = 'superstar-details';
export const QUERY_KEY_SUPERSTAR_TRENDING = 'superstar-trending';
export const QUERY_KEY_SUPERSTAR_ERAS = 'superstar-eras';
export const QUERY_KEY_MY_SUPERSTARS = 'my-superstars';
export const QUERY_KEY_ALL_SUPERSTARS = 'all-superstars';
export const QUERY_KEY_SUPERSTAR_SEARCH_SUGGESTIONS =
  'superstar-search-suggestions';
// #endregion SUPERSTAR QUERY KEY

// #region FLASH MARKET QUERY KEY
export const QUERY_KEY_FLASH_MARKETS_ALL = 'flash-market-all';
export const QUERY_KEY_FLASH_MARKETS_ITEMS = 'flash-market-items';
export const QUERY_KEY_FLASH_MARKETS_CHECK = 'flash-market-check';
// #endregion FLASH MARKET QUERY KEY

// #region LEADERBOARD QUERY KEY
export const QUERY_KEYS_LEADERBOARD_FACTION_FEUD = 'leaderboard-faction-feud';
export const QUERY_KEYS_LEADERBOARD_FACTION_TOP = 'leaderboard-faction-top';
export const QUERY_KEYS_LEADERBOARD_PLAYER_FEUD = 'leaderboard-player-feud';
export const QUERY_KEYS_LEADERBOARD_PLAYER_TOP = 'leaderboard-player-top';
export const QUERY_KEYS_LEADERBOARD_FACTION_BOSS = 'leaderboard-faction-boss';
export const QUERY_KEYS_LEADERBOARD_RBE = 'leaderboard-rbe';
// #endregion LEADERBOARD QUERY KEY

// #region WEBCOIN QUERY KEY
export const QUERY_WEBCOIN_LIVE_FRAMES_AND_AVATARS =
  'webcoin-live-frames-and-avatars';

export const QUERY_WEBCOIN_USD_TO_WEBCOIN_RATE = 'webcoin-usd-to-webcoin-rate';

//user

export const QUERY_KEY_USER_ALL_AVATARS = 'user-info-all-avatars';
export const QUERY_KEY_USER_ALL_FRAMES = 'user-info-all-frames';

// #endregion WEBCOIN QUERY KEY

// #region CLAIM REWARD QUERY KEY
export const MUTATION_KEY_CLAIM_REWARD = 'claim-reward';

// #region Dashboard QUERY KEY
export const QUERY_KEY_DASHBOARD_HIGHLIGHT_ITEMS = 'dashboard-highlight-items';
